import React, { useEffect } from 'react'

import { useLocation } from 'react-router-dom'
import SpotifyIcon from 'mdi-react/SpotifyIcon'
import styled from 'styled-components'

import SecureIcon from 'src/Assets/Svg/pages-icons/Secure.svg?react'
import {
  locationEvent,
  curatorRegistrationStartEvent,
} from 'src/Helpers/TagManager'
import { playlistRequirementsLink } from 'src/Constants/links'
import { PrimaryButton } from 'src/Components/Buttons/PrimaryButton'
import { initiateSpotifyAuth } from 'src/Utils/spotifyAuth'

import {
  SignUpContainer,
  InnerSignUpContainer,
  SignUpLogo,
  SignUpBlock,
  SignUpTitle,
  SignUpSubTitle,
  SafetyBlock,
  InfoText,
  Condition,
  AlreadyHaveAccount,
} from './styles'

const logo = '/logo.png'

const SmallContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const START_INDEX = 8

const SignUp: React.FC = () => {
  const location = useLocation()

  const role = location.pathname.slice(START_INDEX)

  useEffect(() => {
    locationEvent()

    if (role.includes('curator')) {
      curatorRegistrationStartEvent()
    }
  }, [role])

  const onSpotifyClick = (): void => {
    initiateSpotifyAuth({ isSignUp: true })
  }

  return (
    <SignUpContainer>
      <InnerSignUpContainer>
        <SignUpLogo>
          <img alt='logo' width={236} height={52} src={logo} />
        </SignUpLogo>
        <SignUpBlock>
          <SmallContainer>
            <SignUpTitle>Become a Playlist Curator</SignUpTitle>

            <SignUpSubTitle>
              Get paid to review songs and share the ones you love with your
              playlists
            </SignUpSubTitle>
          </SmallContainer>

          <PrimaryButton onClick={onSpotifyClick}>
            <SpotifyIcon />
            Connect with Spotify to start
          </PrimaryButton>

          <SmallContainer>
            <SafetyBlock>
              <SecureIcon />
              <InfoText>
                Your data is safe with us! We request only the necessary
                permissions to create your SoundCampaign profile. Our practices
                comply with GDPR and SOC2 standards, ensuring your information
                is secure and used only for your benefit.
              </InfoText>
            </SafetyBlock>

            {role.includes('curator') && (
              <Condition>
                By signing up, you agree to our&nbsp;
                <a
                  href={playlistRequirementsLink}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Terms & Conditions&nbsp;
                </a>
              </Condition>
            )}
          </SmallContainer>

          <AlreadyHaveAccount>
            <a href='/login'>Already have an account?</a>
          </AlreadyHaveAccount>
        </SignUpBlock>
      </InnerSignUpContainer>
    </SignUpContainer>
  )
}

export default SignUp
